// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8e7e61e96b1e8367","8180":"637fb1df92098611"}[chunkId] + ".css";
};